import type { IconSvgObject } from './types';

const TradeDownIcon: IconSvgObject = [
  ["path", { d: "M20 11V16H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 16L13 9L9 13L4 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TradeDownIcon;
